'use server'

import { apiRequest, ApiResponse } from '../request'

export interface HrTimeEntry {
    id: number
    employeeId: number
    employee?: { id: number; name: string; department: string | null }
    type: 'CLOCK_IN' | 'BREAK_OUT' | 'BREAK_IN' | 'CLOCK_OUT'
    timestamp: string
    latitude: number | null
    longitude: number | null
    ipAddress: string | null
    notes: string | null
    timeSheetId: number | null
    createdAt: string
}

export interface HrTimeSheet {
    id: number
    employeeId: number
    employee?: { id: number; name: string; department: string | null }
    companyId: number
    month: number
    year: number
    status: 'OPEN' | 'CLOSED' | 'APPROVED'
    totalWorkedMinutes: number
    totalOvertimeMinutes: number
    totalNightMinutes: number
    totalAbsenceDays: number
    totalLateDays: number
    approvedById: number | null
    approvedBy?: { id: number; name: string } | null
    approvedAt: string | null
    entries?: HrTimeEntry[]
    createdAt: string
    updatedAt: string
}

export interface ClockEntryPayload {
    employeeId: number
    latitude?: number
    longitude?: number
    notes?: string
}

const BASE = 'hr/time-tracking'

export async function clockIn(data: ClockEntryPayload): Promise<ApiResponse<HrTimeEntry>> {
    return apiRequest<HrTimeEntry>(`${BASE}/clock-in`, { data }, 'post')
}

export async function clockOut(data: ClockEntryPayload): Promise<ApiResponse<HrTimeEntry>> {
    return apiRequest<HrTimeEntry>(`${BASE}/clock-out`, { data }, 'post')
}

export async function breakOut(data: ClockEntryPayload): Promise<ApiResponse<HrTimeEntry>> {
    return apiRequest<HrTimeEntry>(`${BASE}/break-out`, { data }, 'post')
}

export async function breakIn(data: ClockEntryPayload): Promise<ApiResponse<HrTimeEntry>> {
    return apiRequest<HrTimeEntry>(`${BASE}/break-in`, { data }, 'post')
}

export async function getTimeEntries(params: {
    employeeId: number
    month: number
    year: number
}): Promise<ApiResponse<HrTimeEntry[]>> {
    return apiRequest<HrTimeEntry[]>(`${BASE}/entries`, { params })
}

export async function getLastEntry(employeeId: number): Promise<ApiResponse<HrTimeEntry | null>> {
    return apiRequest<HrTimeEntry | null>(`${BASE}/last-entry`, { params: { employeeId } })
}

export async function getTimeSheets(params: {
    month: number
    year: number
    status?: string
}): Promise<ApiResponse<HrTimeSheet[]>> {
    return apiRequest<HrTimeSheet[]>(`${BASE}/timesheets`, { params })
}

export async function getTimeSheet(id: number): Promise<ApiResponse<HrTimeSheet>> {
    return apiRequest<HrTimeSheet>(`${BASE}/timesheets/${id}`, {})
}

export async function closeTimeSheet(id: number): Promise<ApiResponse<HrTimeSheet>> {
    return apiRequest<HrTimeSheet>(`${BASE}/timesheets/${id}/close`, {}, 'post')
}

export async function approveTimeSheet(id: number): Promise<ApiResponse<HrTimeSheet>> {
    return apiRequest<HrTimeSheet>(`${BASE}/timesheets/${id}/approve`, {}, 'post')
}
